/**
 * Linkdropdown
 * @class
 * @constructor
 * @public
 */
class LinkDropdown {
  /**
   * Constructor
   * @returns {class}
   */
  constructor() {
    this.components = document.querySelectorAll('[data-linkdropdown]');

    // Engage engines
    if (this.components) {
      this.components.forEach((component) => {
        this.init(component);
      });

      document.addEventListener('click', (e) => {
        if (!e.target.closest('[data-linkdropdown]')) {
          this.closeAll();
        }
      });
    }

  }

  /**
   * Initialize the component
   * @returns {void}
   */
  init(component) {
    const button = component.querySelector('[data-linkdropdown-button]');
    button.addEventListener('click', () => {
      const isActive = button.classList.contains('is-visible');
      this.closeAll();
      button.classList.toggle('is-visible', !isActive);
    });
  }

  /**
   * Close all dropdowns
   * @returns {void}
   */
  closeAll() {
    this.components.forEach((component) => {
      const button = component.querySelector('[data-linkdropdown-button]');
      button.classList.remove('is-visible');
    });
  }

}

module.exports = LinkDropdown;
